module.exports = __webpack_public_path__ + "img/power-by-vremind.43c430f9.png";